/**
 * Dataset (single-boat) Alarms explore page.
 * Columns: Datetime | Category | Description — no Source, since a dataset is one boat.
 */
import AlarmsReportSection from "../../../../components/reports/AlarmsReportSection";

export default function DatasetAlarmsPage(props: Record<string, unknown>) {
  return <AlarmsReportSection {...props} variant="single" />;
}
